export const METRICS = [
  'minBet',
  'maxBet',
  'reelsCount',
  'linesCount',
  'returnToPlayerPercentage',
] as const;
